import React, { useState } from 'react';
import axios from 'axios';

const useOpneTime = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([]);

    const getOpneTimeData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/webcrawler')
        .then((response) => {
            let data = response.data
            setData(data?.data)
            if (data) {
                onFinish(
                    {
                        axiosMode: "get",
                        status: "success"
                    }
                )
            }
            else {
                onFinish(
                    {
                        axiosMode: "get",
                        status: "error"
                    }
                )
            }

            return {
                ...data
            }
        })
    }
    const postOpneTimeData = (data) => {
        onBefore({ 
            axiosMode: "post" 
        })
        axios.post('/webcrawler',
            data
        )
        .then((response) => {
            let responseData = response.data
            let status = responseData?.status
            if (status === "fail") {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            }
            else {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "success"
                    }
                )
            }
        })
        .catch(() => {
            onFinish(
                {
                    axiosMode: "post",
                    status: "error"
                }
            )
        })
    }
    const patchOpneTimeData = (data) => {
        onBefore({ 
            axiosMode: "patch" 
        });
        axios.patch('/webcrawler',
            data
    )
        .then((response) => {
            let responseData = response.data
            let status = responseData?.status
            if (status === "fail") {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            }
            else {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "success"
                    }
                )
            }
        })
        .catch(() => {
            onFinish(
                {
                    axiosMode: "patch",
                    status: "error"
                }
            )
        })
    }
    const deleteOpneTimeData = (data) => {
        onBefore({ 
            axiosMode: "delete" 
        })
        axios.delete('/webcrawler',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        OpneTimeData: data,
        getOpneTimeData,
        postOpneTimeData,
        patchOpneTimeData,
        deleteOpneTimeData,
    }
}
export { useOpneTime };